/**
 * Loads ECharts on first use (a dynamic import, so it is not in the main
 * bundle or the server-side render). Cached: every chart shares one load.
 * @returns {Promise<typeof import('echarts/core')>}
 */
let loading = null;

export function loadEcharts() {
    if (!loading) {
        loading = import('./echartsSetup').then((m) => m.default);
        loading.catch(() => { loading = null; });
    }
    return loading;
}
